export default __webpack_public_path__ + "static/media/logo.6343b414.png";